module.exports = __webpack_public_path__ + "static/assets/0e2896c458ee2841a7949e0d463523c5.svg";